module.exports = __webpack_public_path__ + "static/select-5fe81e4ccaf65dafb58fafd0412fee39.png";